/*
  dashboard
*/
/**
 * Desktop Dashboard management
 * USE stateful_module.js
 */

/************************************************
		EVENT MANAGEMENT DESKTOP
*************************************************/

//== open/close
$(document.body).on("click", ".dashboard-toggle", function(e) {
  e.preventDefault();
  toggle_dashboard();
});

//== close
$(document.body).on("click", ".close-dashboard", function() {
  toggle_dashboard();
});

//== hide/close dashboard
function toggle_dashboard() {
  $(".dashboard-toggle").toggleClass("active");
  $(".desk_dashboard_iframe").toggleClass("active");
}

/************************************************
		EVENT MANAGEMENT MOBILE
*************************************************/
//== open/close
$(document.body).on("click", ".mob-dashboard-toggle", function() {
  toggle_dashboard_mobile();
});

//== hide/close dashboard
function toggle_dashboard_mobile() {
  $(".mob_dashboard").toggleClass("active");
  $(".mob_dashboard").find(".mob-dashboard-toggle").toggleClass("active");
}

/************************************************
		DASHBOARD'S MODULES MANAGEMENT  -- DESKTOP
*************************************************/
var dash_modules = $(".desk_dashboard [data-type=module][data-state-type]");
//var dash_modules_nb_visible = $(".desk_dashboard [data-type=module][data-state-type]:visible").length;
var dash_modules_nb_visible = $(".desk_dashboard [data-type=module][data-state-type]").filter(function() {
  return $(this).css("display") != "none";
}).length;

//== if less than 3 state modules are visible, display the GC module to fill an empty slot
if (dash_modules_nb_visible < 3) {
  dash_modules.each(function() {
    if ($(this).attr("data-state-type") == "gc") { $(this).show();}
  });
}

//== hide module's parent if this module is hidden
dash_modules.each(function() {
  var module = $(this);
  if (module.css("display") == "none") module.parent().hide();
});

/************************************************
		DASHBOARD'S MODULES MANAGEMENT  -- MOBILE
*************************************************/
var mob_dash_modules = $(".mob_dashboard [data-type=module][data-state-type]");
//var mob_dash_modules_nb_visible = $(".mob_dashboard [data-type=module][data-state-type]:visible").length;
var mob_dash_modules_nb_visible = $(".mob_dashboard [data-type=module][data-state-type]").filter(function() {
  return $(this).css("display") != "none";
}).length;

//== if less than 3 state modules are visible, display the GC module to fill an empty slot
if (mob_dash_modules_nb_visible < 3) {
  mob_dash_modules.each(function() {
    if ($(this).attr("data-state-type") == "gc") { $(this).show();}
  });
}

//== hide module's parent if this module is hidden
mob_dash_modules.each(function() {
  var module = $(this);
  if (module.css("display") == "none") module.parent().hide();
});


/************************************************
    DASHBOARD DISPLAY MANAGEMENT FOR MOBILE
************************************************/
var filter = "hmp_in"; //display only on these pages
filter = filter.split(",");

var mob_dashboard = $(".mob_dashboard");

//== displaying dashboard
if (in_array(PAGE_CODE, filter) && PAGE_CODE) {
  mob_dashboard.show();
  $("main").addClass("has-dashboard");
}



/************************************************
    SHORT PREVIEW ON HOMEPAGE FOR THE USER
************************************************/
if (PAGE_CODE === "hmp_in") {
  //-- open
  toggle_dashboard();
  toggle_dashboard_mobile();

  //-- close
  $(function(){
    setTimeout(function() {toggle_dashboard();toggle_dashboard_mobile(); }, 7000);
  });
}
